import { Flex, Tag, Tooltip } from '@chakra-ui/react';
import { EnvironmentValues } from '@llx/common';

import { config } from '@/environment';

const MainFooter = () => (
  <Flex
    color="grey"
    justifyContent="flex-end"
    alignItems="center"
    height="auto"
    fontSize="11px"
    margin="0"
    padding="12px 25px"
    boxShadow="2xl"
  >
    v{config.VERSION} @copyright 2021 Livelinx{' '}
    {config.ENVIRONMENT !== EnvironmentValues.PROD && (
      <Tooltip label={`You are now testing the "${config.ENVIRONMENT}" environment`}>
        <Tag colorScheme="red" size="sm" marginLeft="5px" padding="2" paddingY="0">
          {config.ENVIRONMENT}
        </Tag>
      </Tooltip>
    )}
  </Flex>
);

export default MainFooter;
